import { useQuery } from '@tanstack/react-query';
import { getChildCharacters } from '../api/characters';

export function useChildCharacters(learnerId) {
  return useQuery({
    queryKey: ['childCharacters', learnerId],
    queryFn: () => getChildCharacters(learnerId),
    enabled: !!learnerId,
    select: (data) => {
      const rawList = Array.isArray(data) ? data : data.characters || [];
      return rawList.map((row) => {
        const c = row.characters || {};
        return {
          id: c.id,
          char: c.simplified_char,
          pinyin: c.pinyin,
          meaning: c.definition_en,
          radical: c.radical,
          stroke_count: c.stroke_count,
          hsk_level: c.hsk_level,
          state: row.state || 'to_learn',
          stateRowId: row.id,
          auto_graduated_session_count: row.auto_graduated_session_count,
          worksheets_completed: row.worksheets_completed,
          character_id: c.id,
        };
      });
    },
  });
}
